import EAButton from "./EAButton";
import React, { useEffect } from "react";
import "../styles/components/transferlist.css";
import { intersection, not } from "../utils/ArrayUtils";
import { FixedSizeList } from "react-window";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";

/**
 * Komponente zur Darstellung einer Transferlist. In der RollenComponent.jsx kann die beispielhafte Anwendung der Komponente mit Filterung
 * eingesehen werden.
 * @param id
 * @param allItems
 * @param selectedItems
 * @param setSelectedItems
 * @param listCaption
 * @param titleProperty
 * @returns {JSX.Element}
 * @constructor
 */
export default function EATransferList({ id, allItems, selectedItems, setSelectedItems, listCaption, titleProperty }) {
    const [checked, setChecked] = React.useState([]);

    const [left, setLeft] = React.useState([]);

    useEffect(() => {
        setLeft(not(allItems, selectedItems));
    }, [allItems, selectedItems]);

    const leftChecked = intersection(checked, left);
    const rightChecked = intersection(checked, selectedItems);

    const handleToggle = (value) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);
    };

    const handleCheckedRight = () => {
        setSelectedItems(selectedItems.concat(leftChecked));
        setLeft(not(left, leftChecked));
        setChecked(not(checked, leftChecked));
    };

    const handleCheckedLeft = () => {
        setLeft(left.concat(rightChecked));
        setSelectedItems(not(selectedItems, rightChecked));
        setChecked(not(checked, rightChecked));
    };

    const handleAllLeft = () => {
        setLeft(left.concat(selectedItems));
        setSelectedItems([]);
    };

    const customList = (items) => (
        <div className="eab-transfer-list-list">
            <span className="eab-transfer-list-caption">{listCaption}</span>
            <FixedSizeList
                height={300}
                itemCount={items.length}
                itemSize={30}
                width="100%"
                itemKey={(index) => items[index][titleProperty] + "-" + index}
            >
                {({ index, style }) => {
                    const value = items[index];
                    const itemId = value[titleProperty] + "-" + index;
                    const labelId = `transfer-list-item-${itemId}-label`;

                    return (
                        <ListItem
                            style={style}
                            key={id}
                            className="eab-transfer-list-listitem"
                            role="listitem"
                            button
                            onClick={handleToggle(value)}
                        >
                            {" "}
                            <ListItemIcon>
                                <Checkbox
                                    checked={checked.indexOf(value) !== -1}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{ "aria-labelledby": labelId }}
                                />
                            </ListItemIcon>
                            <ListItemText id={labelId} primary={value[titleProperty]} />
                        </ListItem>
                    );
                }}
            </FixedSizeList>
        </div>
    );

    return (
        <div className="eab-transfer-list gridl" id={id}>
            {customList(left)}
            <div className="eab-transfer-list-buttons gridl">
                <EAButton
                    id={"transfer-checked-right-" + id}
                    variant="outlined"
                    size="small"
                    onClick={handleCheckedRight}
                    disabled={leftChecked.length === 0}
                    aria-label="Selektierte nach rechts verschieben"
                    label="&gt;"
                />
                <EAButton
                    id={"transfer-checked-left-" + id}
                    variant="outlined"
                    size="small"
                    onClick={handleCheckedLeft}
                    disabled={rightChecked.length === 0}
                    aria-label="Selektierte nach links verschieben"
                    label="&lt;"
                />
                <EAButton
                    id={"transfer-all-left-" + id}
                    variant="outlined"
                    size="small"
                    onClick={handleAllLeft}
                    disabled={selectedItems.length === 0}
                    aria-label="Alle nach links verschieben"
                    label="≪"
                />
            </div>
            {customList(selectedItems)}
        </div>
    );
}
